import { render, staticRenderFns } from "./ControlpanelMenu.vue?vue&type=template&id=ef204778&scoped=true&"
import script from "./ControlpanelMenu.vue?vue&type=script&lang=js&"
export * from "./ControlpanelMenu.vue?vue&type=script&lang=js&"
import style0 from "./ControlpanelMenu.vue?vue&type=style&index=0&id=ef204778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef204778",
  null
  
)

export default component.exports